<!--The content below is only a placeholder and can be replaced.-->

<app-header class="header"></app-header>
<ngx-loading-bar [color]="'#61c250'" [height]="'1px'" [includeSpinner]="false"></ngx-loading-bar>
<main class="container-fluid"> 
    <router-outlet></router-outlet>
   
</main>
 <app-overlay [delay]="overlayDelay">
        <span class=""></span>&nbsp;&nbsp;&nbsp;
        <!--<ifc-loader progressValue="20"></ifc-loader>-->
    </app-overlay>
<app-footer class="ms-auto me-auto"></app-footer>
<!-- <app-footer class="col-md-12 w-90 ms-auto me-auto"></app-footer> -->
<ifc-gototop></ifc-gototop>
<app-toast-container></app-toast-container>
